import React from "react";
export const DimLayer = _ref => {
  let {
    brightness
  } = _ref;
  const color = "rgba(0, 0, 0, " + brightness + ")";
  const defaultDimLayerStyles = {
    position: "absolute",
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    zIndex: 100,
    backgroundColor: color
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "oc-lcw-dim-layer",
    style: defaultDimLayerStyles
  });
};